import React  from "react";
import { FormatMessage } from "react-globalize";
import { getBulletAndText } from "../globalizationUtils";

export default function SectionLegalNotices(props)
{
  let locale = props.locale || 'en';  

  return (
    <div id ="notices">
      <div className="title">
        <h3><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/title" /></h3>
      </div>
      <div id="noticesALASKA" className="div">
        <h4 className="subTitle">{getBulletAndText(locale, "noticesALASKA", "quisqueyanaPolicy/notices/alaska/title")}</h4>
        <div className="noticesALASKA collapse collapsebleDiv">
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/alaska/line1" elements={{phone: <a className="strong" href="tel:+18662713202"></a>}} /></p>
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/alaska/line2" /></p>
            <p>
              <FormatMessage locale={locale} path="quisqueyanaPolicy/notices/alaska/complains/title" /><br/>
              <FormatMessage locale={locale} path="quisqueyanaPolicy/notices/alaska/complains/fax" elements={{fax: <a className="strong" href="tel:+907-465-1230"></a>}}/><br/>
              <FormatMessage locale={locale} path="quisqueyanaPolicy/notices/alaska/complains/email" elements={{email: <a className="strong" href="mailto:msb_licensing@alaska.gov"></a>}}/><br/>
              <address>
                <FormatMessage locale={locale} path="quisqueyanaPolicy/notices/alaska/complains/mail/title" /><br/>
                <FormatMessage locale={locale} path="quisqueyanaPolicy/notices/alaska/complains/mail/address" />
              </address>
            </p>
            <p>
              <FormatMessage locale={locale} path="quisqueyanaPolicy/notices/alaska/questions/title" /><br/>
              <FormatMessage locale={locale} path="quisqueyanaPolicy/notices/alaska/questions/number" elements={{phone: <a className="strong" href="tel:+1907-465-2521"></a>}}/><br/>
            </p>
          </div>
        </div>
        <div id="noticesCALIFORNIA" className="div">
          <h4 className="subTitle">{getBulletAndText(locale, "noticesCALIFORNIA", "quisqueyanaPolicy/notices/california/title")}</h4>
          <div className="noticesCALIFORNIA collapse collapsebleDiv">
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/california/info" /></p>
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/california/web" elements={{link: <a className="strong" href="https://dfpi.ca.gov/"></a>}}/></p>
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/california/phone" elements={{phone1: <a className="strong" href="tel:+1866-275-2677"></a>, phone2: <a className="strong" href="tel:+1916-327-7585"></a>}}/></p>
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/california/email" elements={{email: <a className="strong" href="mailto: consumer.services@dfpi.ca.gov"></a>}}/></p>
            <p>
              <address>
                <FormatMessage locale={locale} path="quisqueyanaPolicy/notices/california/mail/title" /><br/>
                <FormatMessage locale={locale} path="quisqueyanaPolicy/notices/california/mail/office" /><br/>
                <FormatMessage locale={locale} path="quisqueyanaPolicy/notices/california/mail/attn" /><br/>
                <FormatMessage locale={locale} path="quisqueyanaPolicy/notices/california/mail/line1" /><br/>
                <FormatMessage locale={locale} path="quisqueyanaPolicy/notices/california/mail/line2" />
              </address>
            </p>
          </div>
        </div>
        <div id="noticesREFUND" className="div">
          <h4 className="subTitle">{getBulletAndText(locale, "noticesREFUND", "quisqueyanaPolicy/notices/rightToRefund/title")}</h4>
          <div className="noticesREFUND collapse collapsebleDiv">
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/rightToRefund/line1" /></p>
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/rightToRefund/line2" /></p>
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/rightToRefund/line3" elements={{phone: <a className="strong" href="tel:+18662713202"></a>}} /></p>
          </div>
        </div>
        <div id="noticesCOLORADO" className="div">
          <h4 className="subTitle">{getBulletAndText(locale, "noticesCOLORADO", "quisqueyanaPolicy/notices/colorado/title")}</h4>
          <div className="noticesCOLORADO collapse collapsebleDiv">
            <h5><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/colorado/title2" /></h5>
            <h5><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/colorado/title3" /></h5>
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/colorado/line1" /></p>
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/colorado/line2" /></p>
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/colorado/line3" /></p>
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/colorado/line4" elements={{email: <a className="strong" href="mailto: DORA_BankingWebsite@state.co.us"></a> }} /></p>
          </div>
        </div>
        <div id="noticesFLORIDA" className="div">
          <h4 className="subTitle">{getBulletAndText(locale, "noticesFLORIDA", "quisqueyanaPolicy/notices/florida/title")}</h4>
          <div className="noticesFLORIDA collapse collapsebleDiv">
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/florida/info" elements={{phone1: <a className="strong" href="tel:+18009262277"></a>, phone2: <a className="strong" href="tel:+18504879687"></a>}} /></p>
          </div>
        </div>
        <div id="noticesILLINOIS" className="div">
          <h4 className="subTitle">{getBulletAndText(locale, "noticesILLINOIS", "quisqueyanaPolicy/notices/illinois/title")}</h4>
          <div className="noticesILLINOIS collapse collapsebleDiv">
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/illinois/info" elements={{phone: <a className="strong" href="tel:+18884734858"></a>}} /></p>
          </div>
        </div>
        <div id="noticesMARYLAND" className="div">
          <h4 className="subTitle">{getBulletAndText(locale, "noticesMARYLAND", "quisqueyanaPolicy/notices/maryland/title")}</h4>
          <div className="noticesMARYLAND collapse collapsebleDiv">
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/maryland/info" elements={{phone: <a className="strong" href="tel:+18887840136"></a>}} /></p>
          </div>
        </div>
        <div id="noticesTEXAS" className="div">
          <h4 className="subTitle">{getBulletAndText(locale, "noticesTEXAS", "quisqueyanaPolicy/notices/texas/title")}</h4>
          <div className="noticesTEXAS collapse collapsebleDiv">
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/texas/info" elements={{phone1: <a className="strong" href="tel:+18009262277"></a>, phone2: <a className="strong" href="tel:+18772765554"></a>, link: <a className="strong" href="https://www.dob.texas.gov"></a>}} /></p>
          </div>
        </div>
        <div id="noticesWASHINGTON" className="div">
          <h4 className="subTitle">{getBulletAndText(locale, "noticesWASHINGTON", "quisqueyanaPolicy/notices/washington/title")}</h4>
          <div className="noticesWASHINGTON collapse collapsebleDiv">
            <p><FormatMessage locale={locale} path="quisqueyanaPolicy/notices/washington/info" elements={{phone: <a className="strong" href="tel:+13609028703"></a>}} /></p>
          </div>
        </div>
        <div className="quisqueyanaPolicyInfo">
          <FormatMessage locale={locale} path="quisqueyanaPolicy/notices/note" elements={{link: <a className="strong" href="https://www.barri.com/bfgResolution"></a>}}/>
        </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./js/SectionQuisqueyanaPolicy/SectionLegalNotices/SectionLegalNotices.js